module.exports = __webpack_public_path__ + "static/media/01-Follo-creation-campagne.a33101d6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/01-Follo-creation-campagne.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/01-Follo-creation-campagne.pdf
// module chunks = 18